import { ChangeEvent } from 'react';

import { Checkbox } from '~/components/Checkbox';
import { CollapsibleV2, CollapsibleV2Props } from '~/components/CollapsibleV2';
import { ProductPropertyFilterChoice } from '~/types/Product/interface';

import styles from './ProductMultiselectFilter.module.scss';

interface Props
  extends Pick<
    CollapsibleV2Props,
    'expandIconButtonVariant' | 'expandIconButtonType'
  > {
  label: string;
  values?: ProductPropertyFilterChoice[];
  currentValues?: string[];
  onChange: (values: string[]) => void;
  className?: string;
  innerClassName?: string;
  bodyContainerClassName?: string;
  isCollapsed: boolean;
  type?: string;
}

const ProductMultiselectFilter = ({
  label,
  values = [],
  currentValues = [],
  onChange,
  className,
  innerClassName,
  bodyContainerClassName,
  isCollapsed,
  type,
  expandIconButtonVariant,
  expandIconButtonType,
}: Props) => {
  const onChangeValue = (event: ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    const isChecked = event.target.checked;

    const newSelected = isChecked
      ? [...currentValues, value]
      : currentValues.filter((s) => s !== value);

    onChange(newSelected);
  };

  return (
    <CollapsibleV2
      isCollapsed={!currentValues.length && isCollapsed}
      title={label}
      className={className}
      innerClassName={innerClassName}
      bodyContainerClassName={bodyContainerClassName}
      expandIconButtonType={expandIconButtonType}
      expandIconButtonVariant={expandIconButtonVariant}
    >
      {values.map((value, idx) => (
        <Checkbox
          key={`${value.value}_${idx}`}
          checked={currentValues.includes(value.value)}
          value={value.value}
          onChange={(e) => onChangeValue(e)}
          label={
            <>
              {type === 'colorList' && (
                <div
                  style={{ backgroundColor: value.value }}
                  className={styles.colorCircle}
                />
              )}
              {value.label}
            </>
          }
        />
      ))}
    </CollapsibleV2>
  );
};

export default ProductMultiselectFilter;
